/**
 * @module FE-CU26_カメラ詳細画面
 */
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import TabHeader from '../../components/tabHeader/TabHeader.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NotificationHistoryTimeline from '../../components/NotificationHistoryTimeline/NotificationHistoryTimeline.vue';
import NativeApi from '../../api/nativeApi';
import ExternalUrl from '../../api/externalLinks/externalUrls';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU26';

export default {
  name: 'CameraDetail',
  components: {
    Header,
    BreadCrumbList,
    ListPanel,
    TabHeader,
    PcPageTitle,
    MobileFooter,
    PCFooter,
    NotificationHistoryTimeline,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU26カメラ詳細画面.カメラ詳細'), //"カメラ詳細",
      displayName: vm.$vuetify.lang.t('$vuetify.FECU26カメラ詳細画面.カメラ詳細'), //"カメラ詳細",
      panelTitle: {
        place: '',
        type: vm.$vuetify.lang.t('$vuetify.FECU26カメラ詳細画面.カメラ'),
        typeIsBefore: true,
      },
      displayAreaList: [],
      iconDisplayInfo: {
        // #27159 依頼かけつけ初期表示を非表示に変更
        // #30173 全てのボタンの初期値は非表示に変更
        isRushOrderIconVisibility: false, // [依頼駆けつけ]ボタン
        isAnticrimeCameraIconVisibility: false, // [カメラ映像]ボタン
        isNotificationHistoryIconVisibility: false, // [通知履歴]ボタン
        isContactIconVisibility: false, // [ALSOKへのお問い合わせ]ボタン
        isCameraSettingIconVisibility: false, // [カメラ設定]ボタン
      },
      securityImage: require('../../assets/images/camera/camera.png'),
      personImage: require('../../assets/images/camera/person.png'),
      messageImage: require('../../assets/images/camera/message.png'),
      callingImage: require('../../assets/images/camera/calling.png'),
      settingImage: require('../../assets/images/camera/setting.png'),
      equipmentSettingImage: require('../../assets/images/camera/equipmentSetting.png'),
      tabNumber: 0,
      tabs: [
        {
          id: 1,
          title: vm.$vuetify.lang.t('$vuetify.FECU26カメラ詳細画面.カメラメニュー'), //"カメラメニュー"
        },
        {
          id: 2,
          title: vm.$vuetify.lang.t('$vuetify.FECU26カメラ詳細画面.通知履歴ボタン'), //"通知履歴(24時間以内)"
        },
      ],
      lastUpdate: '',
      // 通知履歴一覧を格納
      notificationList: [],
      CONSTANTS: CONSTANTS,
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU26カメラ詳細画面.カメラ詳細'), //"カメラ詳細",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU26カメラ詳細画面.C0001'),
        displayName: vm.$vuetify.lang.t('$vuetify.FECU26カメラ詳細画面.カメラ詳細'), //"カメラ詳細",
        panelTitle: {
          place: '',
          type: vm.$vuetify.lang.t('$vuetify.FECU26カメラ詳細画面.カメラ'),
          typeIsBefore: true,
        },
        tabs: [
          {
            id: 1,
            title: vm.$vuetify.lang.t('$vuetify.FECU26カメラ詳細画面.カメラメニュー'), //"カメラメニュー"
          },
          {
            id: 2,
            title: vm.$vuetify.lang.t('$vuetify.FECU26カメラ詳細画面.通知履歴ボタン'), //"通知履歴(24時間以内)"
          },
        ],
      };
    },
    toggleStatus() {
      return this.$store.state.toggle;
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 初期化処理
     * @param {*} method メソッドパラメータ
     */
    init: async function (method) {
      // 各種APIでデータを取得
      let param = '/api/common/getRoleList';
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };
      // #30173 APP_CU9916 はカメラ設定ボタンの表示/非表示判定しか行ってなかったので呼び出さない
      //await this.APP_CU9916(param, queries, method);
      param = '/api/cameraDetail/init';
      queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
      };
      const cu2601 = await this.APP_CU2601(param, queries, method);
      // カメラ詳細情報をマッピング
      let idIndex = 0;
      let usagePlanName = '';

      switch (cu2601.contentsInfo.cameraInfo.usagePlan) {
        case CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN:
          usagePlanName = '$vuetify.コード.利用プランID.オンライン監視プラン';
          break;
        case CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN:
          usagePlanName = '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン';
          break;
        case CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN:
          usagePlanName = '$vuetify.コード.利用プランID.カメラセルフ監視プラン';
          break;
        default:
          break;
      }

      let districtSplitNumberText = cu2601.contentsInfo.cameraInfo.districtSplitNumber;
      if (cu2601.contentsInfo.cameraInfo.districtSplitNumber === '    ') {
        districtSplitNumberText = '$vuetify.FECU26カメラ詳細画面.メイン地区';
      }

      this.panelTitle = {
        place: `- ${cu2601.contentsInfo.cameraInfo.cameraNickName} `,
        type: '$vuetify.FECU26カメラ詳細画面.カメラ',
        typeIsBefore: true,
      };
      this.displayAreaList.push({
        id: idIndex++,
        title: '$vuetify.FECU26カメラ詳細画面.カメラ詳細表示領域.利用プラン', // "利用プラン",
        text: usagePlanName,
        isVuetifyKey: true,
      });
      this.displayAreaList.push({
        id: idIndex++,
        title: '$vuetify.FECU26カメラ詳細画面.カメラ詳細表示領域.お客様番号', // "お客様番号",
        text: cu2601.contentsInfo.cameraInfo.customerNumber,
      });
      this.displayAreaList.push({
        id: idIndex++,
        title: '$vuetify.FECU26カメラ詳細画面.カメラ詳細表示領域.警備先名', //"警備先名",
        text: cu2601.contentsInfo.cameraInfo.securityDestinationName,
      });
      this.displayAreaList.push({
        id: idIndex++,
        title: '$vuetify.FECU26カメラ詳細画面.カメラ詳細表示領域.地区番号', //"地区番号",
        text: districtSplitNumberText,
      });
      this.displayAreaList.push({
        id: idIndex++,
        title: '$vuetify.FECU26カメラ詳細画面.カメラ詳細表示領域.地区名', //"地区名",
        text: cu2601.contentsInfo.cameraInfo.districtSplitName,
      });
      this.displayAreaList.push({
        id: idIndex++,
        title: '$vuetify.FECU26カメラ詳細画面.カメラ詳細表示領域.ニックネーム対象地区', //"ニックネーム(対象地区)",
        text: cu2601.contentsInfo.cameraInfo.displayDistrictNickname,
      });

      // カメラメニューにマッピング
      // [カメラ映像]ボタン
      const iconDisplayInfo = cu2601.contentsInfo.iconDisplayInfo;
      this.iconDisplayInfo.isAnticrimeCameraIconVisibility =
        iconDisplayInfo.isAnticrimeCameraIconVisibility;
      // [依頼駆けつけ]ボタン
      if (
        cu2601.contentsInfo.cameraInfo.usagePlan != CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN
      ) {
        this.iconDisplayInfo.isRushOrderIconVisibility = iconDisplayInfo.isRushOrderIconVisibility;
      } else {
        this.iconDisplayInfo.isRushOrderIconVisibility = false;
      }
      // [通知履歴]ボタン
      this.iconDisplayInfo.isNotificationHistoryIconVisibility =
        iconDisplayInfo.isNotificationHistoryIconVisibility;
      // [ALSOKへのお問い合わせ]ボタン
      this.iconDisplayInfo.isContactIconVisibility = iconDisplayInfo.isContactIconVisibility;

      // #30173 [カメラ設定]ボタンの表示タイミングを変更
      this.iconDisplayInfo.isCameraSettingIconVisibility = true;

      // 通知履歴にマッピング
      this.lastUpdate = cu2601.contentsInfo.lastUpdate.replace(/-/g, '/');
      let allNotificationList = cu2601.contentsInfo.notificationList;
      let onlyOnce = false;
      allNotificationList.forEach((list) => {
        // 前回ログイン以降の通知 を表示
        if (!onlyOnce && list.isNewMessageLabel) {
          list.newMessageFromHere = true;
          onlyOnce = true;
        }
      });
      this.notificationList = allNotificationList;
    },
    /**
     * ユーザー権限一覧取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     */
    APP_CU9916: async function (param, queries, method) {
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: [
            //       {
            //         customerNumber: "1111111",
            //         districtSplitNumber: "1111111",
            //         displayDistrictUserType: 1,
            //         userAuthority: {
            //           securityOperation: true,
            //           rushOrder: true,
            //           notificationHistory: true,
            //           deviceContorol: true,
            //           contact: true,
            //           nicknameSetting: true,
            //           IDCardKeyInfoSetting: true,
            //           watchOverInfoDeliverySetting: true,
            //           lockUpCheck: true,
            //           targetAtHomeSetting: true,
            //           userManagement: true,
            //           emergencyContact: true,
            //         },
            //       },
            //     ],
            //     cameraInfoList: [
            //       {
            //         customerNumber: "customerNumber",
            //         districtSplitNumber: "1",
            //         deviceID: "1111",
            //         cameraUserType: 1,
            //         userAuthority: {
            //           anticrimeCameraVideos: true,
            //           rushOrder: true,
            //           notificationHistory: true,
            //           contact: true,
            //           nicknameSetting: true,
            //           userManagement: true,
            //           emergencyContact: true,
            //         },
            //       },
            //       {
            //         customerNumber: "customerNumber",
            //         districtSplitNumber: "2",
            //         deviceID: "2222",
            //         cameraUserType: 2,
            //         userAuthority: {
            //           anticrimeCameraVideos: false,
            //           rushOrder: false,
            //           notificationHistory: false,
            //           contact: false,
            //           nicknameSetting: false,
            //           userManagement: false,
            //           emergencyContact: false,
            //         },
            //       },
            //     ],
            //   },
            // };

            for (let i = 0; i < apiData.contentsInfo.cameraInfoList.length; i++) {
              let userAuthority = apiData.contentsInfo.cameraInfoList[i].userAuthority;
              let deviceID = apiData.contentsInfo.cameraInfoList[i].deviceID;
              if (deviceID == this.$store.state.deviceID) {
                if (
                  userAuthority.notificationHistory === false &&
                  userAuthority.nicknameSetting === false
                ) {
                  // カメラ設定表示制御
                  // #29840 [機能修正管理表No.62] 各種設定ボタンが増えたので常に表示
                  // this.iconDisplayInfo.isCameraSettingIconVisibility = false;
                }
                break;
              }
            }
          },
          (error) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        );
    },
    /**
     * カメラ詳細データ取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU2601: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     cameraInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //       cameraNickName: "リビングカメラ",
            //       deviceID: "1111",
            //     },
            //     iconDisplayInfo: {
            //       isRushOrderIconVisibility: true,
            //       isAnticrimeCameraIconVisibility: true,
            //       isNotificationHistoryIconVisibility: true,
            //       isContactIconVisibility: true,
            //     },
            //     cameraUserType: 2,
            //     notificationList: [
            //       {
            //         notificationType: 2,
            //         postedName: "HOME ALSOK",
            //         postedDatetime: "2022-05-02 14:00:00",
            //         contentType: 0,
            //         notificationPriority: 4,
            //         serviceType: 1,
            //         isPersonNotification: false,
            //       },
            //     ],
            //     lastUpdate: "2022-05-02 14:30:00",
            //   },
            // };

            // TODO:防犯カメラボタンを押した時のだいぶリンクのURLを組み立てる。どのようなリンクを組み立てるのかは未決。
          },
          (error /* eslint-disable-line */) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * カメラ映像ボタン押下時の遷移先を制御
     */
    goAnticrimeCamera: function () {
      if (this.$isMobile) {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        let homeLinkStoreUrl = ExternalUrl.homeLinkStoreUrl;

        if (/android/i.test(userAgent)) {
          homeLinkStoreUrl = ExternalUrl.homeLinkWebPlayStoreUrl;
        }

        if (this.$isMobileApp) {
          const homeLinkAppUrl = `homelink://device?id=${this.$store.state.deviceID}`;
          // カメラアプリの該当カメラ映像閲覧画面に遷移する
          NativeApi.openExternalApp(homeLinkAppUrl, homeLinkStoreUrl);
        } else {
          window.open(homeLinkStoreUrl, '_blank'); // 別タブで外部リンクを開く
        }
      } else {
        // PCブラウザの場合はAppStoreのアプリダウンロード画面に遷移する
        window.open(ExternalUrl.homeLinkWebUrl, '_blank'); // 別タブで外部リンクを開く
      }
    },
    /**
     * 通知履歴ボタン押下時処理
     */
    goNotificationHistory: function () {
      this.$store.commit('setFromType', { fromType: 2 });
      this.$router.push('notificationHistory');
    },
    /**
     * 戻るボタン押下時処理
     */
    clickBack: function () {
      this.$store.commit('setBackButtonFlag', { backButtonFlag: true });
      this.$router.back();
    },
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
  watch: {
    tabNumber(num) {
      this.$store.commit('setCameraDetailTabNumber', { cameraDetailTabNumber: num });
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);
    this.tabNumber = this.$store.state.cameraDetailTabNumber;
    this.$store.state.currentDisplayType = 2;

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //以降は、ローディングマークを出して警備ユニットとの通信なので、ここで画面表示
    this.isShowPage = true;

    let method = 'post';
    await this.init(method);
  },
};
